import type { FilterType } from "@up/data";

export const CohortFilters = function CohortFilters({
  filters,
  handleFilterToggle,
}: {
  filters: Array<FilterType>;
  handleFilterToggle: (filterName: string, optionName: string) => void;
}) {
  return (
    <>
      {filters
        .filter((f) => f.enabled)
        .map(function (filter) {
          return (
            <div
              key={filter.name}
              className="mb-4 items-center flex flex-row flex-wrap"
              data-element="cohort-list-filters-section"
            >
              <div className="mr-4 font-bold">Filter by {filter.name}:</div>
              {filter.type === "radio" &&
                filter.options.map(function (option, index) {
                  return (
                    <label
                      key={index}
                      className="cohort-list-filter-option relative mr-4 cursor-pointer select-none"
                      data-element="cohort-list-filter-option"
                    >
                      <input
                        checked={option.selected}
                        name={`${filter.name.replace(
                          " ",
                          "",
                        )}${option.value.replace(" ", "")}`}
                        onClick={() => {
                          handleFilterToggle(filter.name, option.value);
                        }}
                        onChange={() => {
                          /* empty */
                        }}
                        type="checkbox"
                        value={option.value}
                      />
                      <span>
                        <span>{option.displayName}</span>
                      </span>
                    </label>
                  );
                })}

              {filter.type === "select" && (
                <select
                  name={filter.name.replace(" ", "")}
                  onChange={(e) => {
                    handleFilterToggle(filter.name, e.target.value);
                  }}
                  style={{ maxWidth: "100%" }}
                >
                  <option value="">All Courses</option>
                  {filter.options.map(function (option, index) {
                    return (
                      <option key={index} value={option.value}>
                        {option.displayName}
                      </option>
                    );
                  })}
                </select>
              )}
            </div>
          );
        })}
    </>
  );
};
